module.exports = "//static.hsappstatic.net/react-codemirror/static-1.5571/theme/hubspot-canvas-dark.sass"